import { Store, useStore } from '@data/store'

export function useCurrentRoute(): Store['route']['currentRoute'] {
    const currentRoute = useStore((state) => state.route.currentRoute)

    return currentRoute
}

export function getCurrentRoute(): Store['route']['currentRoute'] {
    return useStore.getState().route.currentRoute
}

export function useMobileNavBarCustomTitle(): Store['route']['mobileNavBarCustomTitle'] {
    const mobileNavBarCustomTitle = useStore((state) => state.route.mobileNavBarCustomTitle)

    return mobileNavBarCustomTitle
}

export function getMobileNavBarCustomTitle(): Store['route']['mobileNavBarCustomTitle'] {
    return useStore.getState().route.mobileNavBarCustomTitle
}
